<div class="container">
  <div class="content">
    <div class="title">
      <div class="back" (click)="back()">
        <img
          src="../../../../assets/images/help/Icon-back.svg"
          [width]="30"
          [height]="30"
          alt=""
        />返回
      </div>
      <div class="platform">
        <app-image
          [fileid]="article?.tag_cover"
          width="100px"
          height="50px"
        ></app-image>
        <span class="divider"></span>
        <span class="summarize">
          {{ article?.title }}
        </span>
      </div>
    </div>
    <mat-spinner *ngIf="loading" [diameter]="60"></mat-spinner>
    <div class="detail" *ngIf="!loading">
      <div class="select">
        <div class="theme">相关文章</div>
        <div class="categories">
          <div
            class="categorie"
            *ngFor="let item of articles"
            [ngClass]="{ active: item.id === articleID }"
            (click)="gotoArticle(item.id)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="card" [innerHTML]="article?.content"></div>
    </div>
  </div>
</div>
